import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'

import {
  Box,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import useStyles from './styles'
import constants from 'constants/index'

const PermissionSection = ({
  isShow,
  availableUsers,
  departments,
  permissionsIsLoading,
  usersIsLoading,
  departmentsIsLoading,
}) => {
  const classes = useStyles()
  const { control, errors, register, setValue, watch } = useFormContext()

  const {
    DEPARTMENT_ACCESS_PERMISSION_ID,
    PERMISSIONS_CONTROL_ITEMS,
    USER_ACCESS_PERMISSION_ID,
  } = constants.documents

  const visibilityType = watch('visibilityType')
  const selectedUsers = watch('selectedUsers')
  const selectedDepartments = watch('selectedDepartments')

  useEffect(() => {
    register({ name: 'selectedUsers' })
    register({ name: 'selectedDepartments' })
  }, [register])

  const ControlledRadioGroup = ({ value, onChange, children }) => {
    const handleChange = (event) => {
      onChange(event.target.value)
    }

    return (
      <RadioGroup value={value || ''} onChange={handleChange}>
        {children}
      </RadioGroup>
    )
  }

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h6" gutterBottom>
        Permissões
      </Typography>
      <Controller
        as={
          <ControlledRadioGroup>
            <Box display="flex" flexDirection="column">
              {PERMISSIONS_CONTROL_ITEMS.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <FormControlLabel
                      value={item?.name}
                      control={<Radio size="small" />}
                      label={item?.label}
                      className={classes.formControlLabel}
                      disabled={isShow}
                    />

                    {item?.name === USER_ACCESS_PERMISSION_ID &&
                      visibilityType === USER_ACCESS_PERMISSION_ID && (
                        <Box pl={4} mt={1} mb={2}>
                          <Autocomplete
                            fullWidth
                            multiple
                            options={availableUsers || []}
                            disabled={isShow}
                            filterSelectedOptions
                            value={selectedUsers || []}
                            getOptionLabel={(option) => option.name || ''}
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            noOptionsText="Nenhum usuário encontrado"
                            loading={permissionsIsLoading || usersIsLoading}
                            loadingText="Carregando usuários..."
                            onChange={(_, newValue) => {
                              setValue('selectedUsers', newValue, {
                                shouldValidate: true,
                                shouldDirty: true,
                              })
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Selecione os usuários"
                                variant="outlined"
                                error={!!errors?.selectedUsers}
                                helperText={errors?.selectedUsers?.message}
                              />
                            )}
                          />
                        </Box>
                      )}

                    {item?.name === DEPARTMENT_ACCESS_PERMISSION_ID &&
                      visibilityType === DEPARTMENT_ACCESS_PERMISSION_ID && (
                        <Box pl={4} mt={1} mb={2}>
                          <Autocomplete
                            fullWidth
                            multiple
                            disabled={isShow}
                            options={departments || []}
                            filterSelectedOptions
                            value={selectedDepartments || []}
                            getOptionLabel={(option) => option.name || ''}
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            noOptionsText="Nenhum departamento encontrado"
                            loading={
                              permissionsIsLoading || departmentsIsLoading
                            }
                            loadingText="Carregando departamentos..."
                            onChange={(_, newValue) => {
                              setValue('selectedDepartments', newValue, {
                                shouldValidate: true,
                                shouldDirty: true,
                              })
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Selecione os departamentos"
                                variant="outlined"
                                error={!!errors?.selectedDepartments}
                                helperText={
                                  errors?.selectedDepartments?.message
                                }
                              />
                            )}
                          />
                        </Box>
                      )}
                  </Fragment>
                )
              })}
            </Box>
          </ControlledRadioGroup>
        }
        control={control}
        name="visibilityType"
      />
      {!!errors?.visibilityType && (
        <FormHelperText error={!!errors?.visibilityType}>
          {<>{errors?.visibilityType?.message}</>}
        </FormHelperText>
      )}
    </Box>
  )
}

PermissionSection.propTypes = {
  isShow: PropTypes.bool,
  availableUsers: PropTypes.array,
  departments: PropTypes.array,
  permissionsIsLoading: PropTypes.bool,
  usersIsLoading: PropTypes.bool,
  departmentsIsLoading: PropTypes.bool,
}

export default PermissionSection
